import axios from "axios";

export class AnnouncementsService {
  async saveAnnouncements(type: string, id: number, data): Promise<any> {
    return await axios.post(`api/announcements/${type}/${id}`, data);
  }

  async getAnnouncements(type: string, id: number): Promise<any> {
    return await axios.get(`api/announcements?${type}=${id}`);
  }
  async deleteAnnouncements(id: number): Promise<any> {
    return await axios.delete(`api/announcements/${id}`);
  }
}
